export default __webpack_public_path__ + "static/media/Fiche Assertif.16acc8d4.pdf";